<p-tabView>
  <p-tabPanel header="Perfil de Segurança">
    <fieldset>
      <div class="p-fluid">
        <div class="p-field p-grid" *ngIf="entidade.id">
          <label for="id" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Id:</label>
          <div class="p-col-12 p-md-10">
            <input pInputText type="text" name="id" disabled readonly [ngModel]="entidade.id" />
          </div>
        </div>
        <div class="p-field p-grid">
          <label for="nome" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0" [ngClass]="{'error' : invalid.nome && submit}">Nome:</label>
          <div class="p-col-12 p-lg-10">
            <input pInputText type="text"  [disabled]="entidade.id !== undefined"  name="nome" [(ngModel)]="entidade.nome" />
          </div>
        </div>
        <div class="p-field p-grid">
          <label for="descricao" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0" [ngClass]="{'error' : invalid.descricao && submit}">Descrição:</label>
          <div class="p-col-12 p-lg-10">
            <input pInputText type="text" name="descricao" [(ngModel)]="entidade.descricao" />
          </div>
        </div>

        <div class="p-field p-grid">
          <label for="tipoUsuario" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0" [ngClass]="{'error' : invalid.tipoUsuario && submit}">Tipo de Usuário:</label>
          <div class="p-col-12 p-lg-10">
            <p-dropdown
              placeholder="Selecione o tipo de usuário"
              [options]="tiposUsuariosItens"
              filter="true"
              [(ngModel)]="entidade.tipoUsuario"
              [disabled]="entidade.id !== undefined">
            </p-dropdown>
          </div>
        </div>

      </div>
    </fieldset>
    <br />
    <fieldset ngModel="entidade.dominio == 'BACKEND'" ngDefaultControl>
      <legend class="p-fildset-title">Dados do Backend</legend>
      <div class="p-fluid">
        <p-pickList
          [source]="perfilRecursosSegurancaBack"
          [target]="recursosBack"
          [responsive]="true"
          [sourceStyle]="{'height':'300px'}"
          [targetStyle]="{'height':'300px'}"
          filterBy="recursoSeguranca.nome">
          <ng-template let-perfilRecursoSeguranca pTemplate="item">
            <div class="p-helper-clearfix p-text-break">
              <span *ngIf="perfilRecursoSeguranca.recursoSeguranca.requerAutenticacao === true" class="label label-warning">
                <i class="pi pi-lock" aria-hidden="true"></i> RA
              </span>
              <span *ngIf="perfilRecursoSeguranca.recursoSeguranca.requerAutenticacao === false" class="label label-info">
                <i class="pi pi-lock-open" aria-hidden="true"></i> NRA
              </span>
              {{  getAbreviacao(perfilRecursoSeguranca.recursoSeguranca.metodo) }} - {{perfilRecursoSeguranca.recursoSeguranca.nome}}
            </div>
          </ng-template>
        </p-pickList>
      </div>
      <div class="p-fluid">
        <div class="p-field m-t-5">
          <strong>Legenda: </strong>
          <span class="texto-legenda">TODOS - <span class="p-text-bold"> T </span> | </span>
          <span class="texto-legenda">POST - <span class="p-text-bold">PO </span> | </span>
          <span class="texto-legenda">GET - <span class="p-text-bold">G </span> | </span>
          <span class="texto-legenda">PUT - <span class="p-text-bold">PU </span> | </span>
          <span class="texto-legenda">DELETE - <span class="p-text-bold">D</span> | </span>
          <span class="texto-legenda">PATCH - <span class="p-text-bold">PA</span> </span>
        </div>
      </div>
    </fieldset>
    <br><br>
    <fieldset ngModel="entidade.dominio == 'FRONTEND'" ngDefaultControl>
      <legend class="p-fildset-title">Dados do Frontend</legend>
      <div class="p-fluid">
        <p-pickList
          [source]="perfilRecursosSegurancaFront"
          [target]="recursosFront"
          [responsive]="true"
          [sourceStyle]="{'height':'300px'}"
          [targetStyle]="{'height':'300px'}"
          filterBy="recursoSeguranca.nome">
          <ng-template let-perfilRecursoSeguranca pTemplate="item">
            <div class="p-helper-clearfix p-text-break">
                  <span *ngIf="perfilRecursoSeguranca.recursoSeguranca.requerAutenticacao === true" class="label label-warning">
                    <i class="pi pi-lock" aria-hidden="true"></i> RA</span>
              <span *ngIf="perfilRecursoSeguranca.recursoSeguranca.requerAutenticacao === false" class="label label-info">
                    <i class="pi pi-lock-open" aria-hidden="true"></i> NRA</span>
              - {{perfilRecursoSeguranca.recursoSeguranca.nome}}
            </div>
          </ng-template>
        </p-pickList>
      </div>
      <div class="p-fluid">
        <div class="p-field m-t-5">
          <strong>Legenda: </strong>
          <span class="label label-warning p-text-bold"><i class="pi pi-lock"></i> RA
          </span>
          <label class="texto-legenda"> -  Requer Autenticação |&nbsp;</label>
          <span class="label label-info p-text-bold"><i class="pi pi-lock-open"></i> NRA
          </span>
          <label class="texto-legenda"> - Não Requer Autenticação</label>
        </div>
      </div>
    </fieldset>
  </p-tabPanel>
  <p-tabPanel header="Auditoria" [disabled]="entidade.id === undefined">
    <div class="p-fluid">
      <div class="p-grid">
        <div class="p-col-12 p-lg-3 p-text-bold">Inserção - Data:</div>
        <div class="p-col-12 p-lg-9">{{entidade.auditoriaDataInsercao | date: 'dd/MM/yyyy HH:mm:ss'}}</div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-lg-3 p-text-bold">Inserção - Usuário:</div>
        <div class="p-col-12 p-lg-9">{{entidade.auditoriaUsuarioInsercao?.nome}}</div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-lg-3 p-text-bold">Última alteração - Data:</div>
        <div class="p-col-12 p-lg-9">{{entidade.auditoriaData | date: 'dd/MM/yyyy HH:mm:ss'}}</div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-lg-3 p-text-bold">Última alteração - Usuário:</div>
        <div class="p-col-12 p-lg-9">{{entidade.auditoriaUsuario?.nome}}</div>
      </div>
    </div>
  </p-tabPanel>
</p-tabView>
